import { render, staticRenderFns } from "./BibliomapTemp.vue?vue&type=template&id=09de4656&"
import script from "./BibliomapTemp.vue?vue&type=script&lang=js&"
export * from "./BibliomapTemp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports